import axios from 'axios';
import { getSessionStorage } from '../utils/helpers';
import AuthService from '../SDA/AuthService';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { getEnvConfig } from '../utils/getEnv';

const env = getEnvConfig();
console.log('Environment Configuration:', env);

export const api = axios.create({
  baseURL: `${env.MICROSERVICE_BASE_URL}`,
  withCredentials: false,
  crossDomain: true,
  headers: {
    'Content-Type': 'application/json',
    ApiKey: `${env.MICROSERVICE_API_KEY}`
  }
});

export const apiPython = axios.create({
  baseURL: `${env.PYTHON_BASE_URL}`,
  withCredentials: false,
  crossDomain: true,
  headers: {
    'Content-Type': 'application/json',
    ApiKey: `${env.MICROSERVICE_API_KEY}`
  }
});

apiPython.interceptors.request.use(
  (config) => {
    const token = AuthService.decrypt(getSessionStorage('SI_IT'));
    if (token) {
      config.headers.Authorization = `bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const api2 = axios.create({
  baseURL: `${env.AC_BASE_URL}`,
  withCredentials: false,
  crossDomain: true,
  headers: {
    'Content-Type': 'application/json',
    ApiKey: `${env.MICROSERVICE_API_KEY}`
  }
});

export const apiRephrase = axios.create({
  baseURL: `${env.REPHRASE_URL}`,
  withCredentials: false,
  crossDomain: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(
  (config) => {
    const loggedUserID = getSessionStorage('USER_ID');
    config.headers.LoggedUserID = loggedUserID;
    const token = AuthService.decrypt(getSessionStorage('SI_IT'));
    if (token) {
      config.headers.Authorization = `bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const setupResponseInterceptor = (navigate) => {
  api.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      const status = error.response ? error.response.status : null;
      if (status) {
        switch (status) {
          case 401:
            AuthService.clearSession();
            navigate('/unauthorized');
            break;
          case 403:
            AuthService.clearSession();
            navigate('/session-timeout');
            break;
          case 404:
            AuthService.clearSession();
            navigate('/unauthorized');
            break;
          default:
            break;
        }
      }
      return Promise.reject(error);
    }
  );
};

const ApiInterceptorComponent = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setupResponseInterceptor(navigate);
  }, [navigate]);

  return null;
};

export default ApiInterceptorComponent;
